var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseToast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4688 10L14.8438 13.375C15.0312 13.5625 15.0312 13.9062 14.8438 14.0938L14.0625 14.875C13.875 15.0625 13.5312 15.0625 13.3438 14.875L10 11.5L6.625 14.875C6.4375 15.0625 6.09375 15.0625 5.90625 14.875L5.125 14.0938C4.9375 13.9062 4.9375 13.5625 5.125 13.375L8.5 10L5.125 6.65625C4.9375 6.46875 4.9375 6.125 5.125 5.9375L5.90625 5.15625C6.09375 4.96875 6.4375 4.96875 6.625 5.15625L10 8.53125L13.3438 5.15625C13.5312 4.96875 13.875 4.96875 14.0625 5.15625L14.8438 5.9375C15.0312 6.125 15.0312 6.46875 14.8438 6.65625L11.4688 10Z",
    fill: "#6E737E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseToast);
export default __webpack_public_path__ + "static/media/closeToast.8c43ee39fb8a4853f7f2a07738982099.svg";
export { ForwardRef as ReactComponent };